import { render, staticRenderFns } from "./accountsReceive.vue?vue&type=template&id=00089c3a&scoped=true"
import script from "./accountsReceive.vue?vue&type=script&lang=js"
export * from "./accountsReceive.vue?vue&type=script&lang=js"
import style0 from "./accountsReceive.vue?vue&type=style&index=0&id=00089c3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00089c3a",
  null
  
)

export default component.exports